import LazyStandalonePackageEmbedContainer from "@pathwright/features/src/modules/package/embed/LazyStandalonePackageEmbedContainer"
import LazyStandalonePricingEmbedContainer from "@pathwright/features/src/modules/pricing/embed/LazyStandalonePricingEmbedContainer"
import { Route, Switch } from "react-router-dom"

export const packageEmbedRoute = {
  path: "/embed/package/",
  component: LazyStandalonePackageEmbedContainer
}

export const pricingEmbedRoute = {
  path: "/embed/pricing/",
  component: LazyStandalonePricingEmbedContainer
}

const EmbedsRoute = () => (
  <Switch>
    <Route
      path={packageEmbedRoute.path}
      component={packageEmbedRoute.component}
      exact
    />
    <Route
      path={pricingEmbedRoute.path}
      component={pricingEmbedRoute.component}
      exact
    />
  </Switch>
)

EmbedsRoute.path = "/embed/"

export default EmbedsRoute
